import React from 'react';
import AlternateErrors from './alternate_errors';
import { shallow, mount } from 'enzyme';

let wrapped1;
let wrapped2;
let wrapped3;

describe('Alternate Errors Component existance/structure', () => {
  const altObj1 = {
    alternateRef: { current: { value: 'Test Alternate 1' } },
    isInvalid: false,
    isEmpty: false,
    isLong: false,
    isRepeated: false,
    isName: false,
  };
  beforeAll(() => {
    wrapped1 = shallow(<AlternateErrors {...altObj1} />);
  });

  it('exists', () => {
    expect(wrapped1.exists()).toBe(true);
  });

  it('has 0 error divs', () => {
    expect(wrapped1.find('div.ld-alert').length).toEqual(0);
  });
});

describe('Alternate Errors Component functionality', () => {
  const altObj2 = {
    alternateRef: { current: { value: 'Test Alternate 2' } },
    isInvalid: false,
    isEmpty: true,
    isLong: false,
    isRepeated: false,
    isName: false,
  };

  const altObj3 = {
    alternateRef: { current: { value: 'Test Alternate 3' } },
    isInvalid: true,
    isEmpty: false,
    isLong: true,
    isRepeated: false,
    isName: false,
  };

  beforeAll(() => {
    wrapped2 = mount(<AlternateErrors {...altObj2} />);
    wrapped3 = mount(<AlternateErrors {...altObj3} />);
  });
  it('it has 1 error divs and correct error message', () => {
    expect(wrapped2.find('div.ld-alert').length).toEqual(1);
    expect(wrapped2.text()).toEqual("This field can't be submited empty.");
  });

  it('it has 2 error divs', () => {
    expect(wrapped3.find('div.ld-alert').length).toEqual(2);
  });
});
